import StatusIndicator from './statusIndicator';
import styles from './styles.module.css';
import UnlinkIcon from '@/assets/icons/unlink.svg?react';
import { DataTableColumn } from '@/components/DataTable';
import { Button } from '@/components/Form/Button';
import { TURBINE_IS_ACTIVE } from '@/solaris-lens-common-lib/src/constants/turbines';

export const getTurbinesColumns = <
  T extends {
    status?: string;
    isActive?: boolean;
    id?: string;
    name?: string;
    model?: string;
    type?: string;
    subType?: string;
    maxCapacityMW?: string;
    maxCapacity?: string;
    genTotalKwAnalog?: {
      max: number;
    };
  }
>(
  showActions: boolean = true,

  onActionClick?: (item: T) => void
): DataTableColumn<T>[] => {
  const baseColumns: DataTableColumn<T>[] = [
    {
      field: 'id',
      headerName: 'SERIAL NUMBER',
      width: showActions ? '16%' : '20%',
      sortable: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>{row.id}</div>
      )
    },
    {
      field: 'name',
      headerName: 'NAME',
      width: '20%',
      sortable: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>{row.name || ''}</div>
      )
    },
    {
      field: 'model',
      headerName: 'MODEL',
      width: showActions ? '16%' : '20%',
      sortable: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>
          {row.subType || row.type || ''}
        </div>
      )
    },
    {
      field: 'genTotalKwAnalog',
      headerName: 'MAX CAPACITY',
      width: showActions ? '16%' : '20%',
      sortable: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>
          {(row.maxCapacity && `${row.maxCapacity} MW`) || ''}
        </div>
      )
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: showActions ? '16%' : '20%',
      sortable: true,
      renderCell: ({ row }) => (
        <StatusIndicator
          location={{
            status: row.isActive
              ? TURBINE_IS_ACTIVE.ACTIVE
              : TURBINE_IS_ACTIVE.INACTIVE
          }}
        />
      )
    },
    {
      headerName: 'ACTIONS',
      width: '16%',
      renderCell: ({ row }) => (
        <Button
          label="UNASSIGN"
          icon={UnlinkIcon}
          iconPosition="right"
          onClick={() => onActionClick?.(row)}
          color="blue"
          solid={false}
          size="small"
          className={styles.unassignButton}
        />
      )
    }
  ];

  if (showActions) {
    return baseColumns;
  } else {
    return baseColumns.filter(column => column.headerName !== 'ACTIONS');
  }
};
